import "./index.less";
import * as React from "react";
import { AnalysisTileEnum, FitLevelEnum } from "@atman/business";
import { ViewFilterType } from "../";
import FitLevelLegendElement from "./components/FitLevelLegendElement";

export interface IFitLevelLegendProps {
    fitLevelCountMap: Map<FitLevelEnum, number>;
    onLegendItemClick: (fitLevel: FitLevelEnum | "showAll") => void;
    currentViewFilter?: ViewFilterType;
    tile: AnalysisTileEnum;
}

export const FitLevelLegend: React.FC<IFitLevelLegendProps> = (props) => {
    const { fitLevelCountMap, onLegendItemClick, currentViewFilter, tile } = props;

    return (
        <div id="FitLevelLegend">
            <h5>{"global.filters".localize()}</h5>
            <div className="fit-level-buttons">
                {[...fitLevelCountMap.entries()].map(([fitLevel, count]) => (
                    <FitLevelLegendElement
                        fitLevel={fitLevel}
                        count={count}
                        key={fitLevel}
                        onClick={onLegendItemClick}
                        active={fitLevel === currentViewFilter}
                        tile={tile}
                    />
                ))}
            </div>
        </div>
    );
};
